import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as common from "lib/appserver/entityHeaders/common";

/**
 * Max quantity of each shop item allowed in basket per student.
 * May be unreachable if shop item quantity available is lower.
 */
const MAX_BASKET_QUANTITY = 100;

const ShopItem = new Immutable.Record({
  ...common.defaultProperties,
  name: undefined,
  price: undefined,
  quantity: undefined
}, "ShopItem");

function buildShopItemFromAppserver(rawShopItem) {
  return ShopItem({
    name: rawShopItem.name,
    price: floatToMoney(rawShopItem.price),
    quantity: rawShopItem.quantity,
    ...common.appserverAdapter(rawShopItem)
  });
}

ShopItem.MAX_BASKET_QUANTITY = MAX_BASKET_QUANTITY;
ShopItem.fromAppserver = buildShopItemFromAppserver;
export default ShopItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/ShopItem.js